enum AddOwnershipPages {
    AddOwnershipLandingPage,
    OwnerDeviationsPage,
    NewOwnerDecimalInterest,
    DeviationDecimalInterest,
    NewDeviationInfoForm,
    NewOwnerInfoForm,
}

export default AddOwnershipPages;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/AddOwnershipPages.ts